import React from "react";
import styled from "styled-components";
import { useDispatch, useSelector } from "react-redux";
import Action from "./Action";
import vmTheme from "../constants/theme";
import { font } from "../constants/font";
import { STATIC_PATH } from "../constants/config";
import Typography from "./Typography";
import { Modal } from "./modal";
import { showFocusSpaceErrorModal } from "../redux/actions/modalAction";
import content from "../constants/content";

export const SpaceUnavailableWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding:7px;
`;

export const TextContainerCenter = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 24px;
`;

export const BackgroundCircle = styled.div`
width: 45px;
height: 45px;
border-radius: 50%;
background: #FFDEDE;
display: flex;
padding: 8px;
justify-content: center;
align-items: center;
`;


const NotEnoughSpaceModal = () => {
  const theme = useSelector((state) => state.app.get("theme"));
  const { show } = useSelector((state) => state.app.get("focusSpaceError").toJS());
  const dispatch = useDispatch();

  const handleClose = () => {
    dispatch(showFocusSpaceErrorModal({ show: false }));
  }

  return (
    <div>
      <Modal
        showModal={show}
        useWrapper={false}
        onClose={handleClose}
        borderRadius="16px"
        width={"396px"}
        height={"228px"}
        preventClose={true}
        padding={"0px"}
      >
        <SpaceUnavailableWrapper>
          <TextContainerCenter>
            <BackgroundCircle>
              <img src={`${STATIC_PATH}error.svg`} alt="Unavailable Icon" />
            </BackgroundCircle>
            <Typography
              content={content.NOT_ENOUGH_SPACE}
              color={vmTheme[theme].tertiaryColor}
              font={font.bold_16_400}
              height="19px"
              align="center"
              enableTrim={false}
            />
          </TextContainerCenter>
          <Action
            background={vmTheme[theme].polarColor}
            borderRadius="8px"
            font={font.boldBase}
            fontColor={vmTheme[theme].tabTextColor}
            width="86px"
            height="36px"
            onClick={handleClose}
            text={content.GOT_IT}
            borderWidth={`1px`}
            borderColor={vmTheme[theme].searchBorder}
            hoverColor={false}
            showHoverColor={false}
          />
        </SpaceUnavailableWrapper>
      </Modal>
    </div>
  );
};

export default NotEnoughSpaceModal;
